import http from '../../axios'
import store from '../../store'

export default {
  state: {
    detailRowsDataDay: {},
    detailRowsDataMonth: {},
    detailRowsStatus: {},
    allExtensions: [],
    pbxUrl: null
  },
  getters: {
    detailRowsDataDay(state) {
      return state.detailRowsDataDay
    },
    detailRowsDataMonth(state) {
      return state.detailRowsDataMonth
    },
    detailRowsStatus(state) {
      return state.detailRowsStatus
    },
    allExtensions(state) {
      return state.allExtensions
    },
    pbxUrl(state) {
      return state.pbxUrl
    }
  },
  mutations: {
    addDetailRowDataDay(state, { id, data }) {
      state.detailRowsDataDay[id] = data
    },
    addDetailRowDataMonth(state, { id, data }) {
      state.detailRowsDataMonth[id] = data
    },
    addDetailRowStatus(state, { id, data }) {
      state.detailRowsStatus[id] = data
    },
    addAllExtensions(state, data) {
      state.allExtensions = data
    },
    setPbxUrl(state, val) {
      state.pbxUrl = val
    }
  },
  actions: {
    async createExtension({ commit }, payload) {
      commit('setError', null)
      try {
        const response = await http.post(
          `sip/provisioningwa/api/v2/tenant/extension`,
          {
            tenant_id: store.getters.currentAccount.id,
            status: true,
            ...payload
          }
        )
        if (response.data.success) {
          return {
            success: true,
            data: { ...response.data.data }
          }
        } else {
          commit('setError', response.data.error.message)
        }
      } catch (error) {
        if (error.response) {
          commit('setError', error.response.data.error.message)
          return {
            success: false,
            errors: { ...error.response.data.error.errors }
          }
        } else {
          commit('setError', error.message)
          return {
            success: false,
            errors: {}
          }
        }
      }
    },
    async fetchLastExtensionNumber({ commit }) {
      commit('setError', null)
      try {
        const response = await http.get(
          `sip/provisioningwa/api/v2/tenant/extension/available-number?tenant_id=${store.getters.currentAccount.id}`
        )
        if (response.data.success) {
          return {
            success: true,
            data: response.data.data.availableExtension
          }
        } else {
          commit('setError', response.data.error.message)
          return {
            success: false,
            errors: response.data.error.errors
          }
        }
      } catch (error) {
        if (error.response) {
          commit('setError', error.response.data.error.message)
          return {
            success: false,
            errors: {}
          }
        } else {
          commit('setError', error.message)
          return {
            success: false,
            errors: {}
          }
        }
      }
    },
    async fetchExtension({ commit }, id) {
      commit('setError', null)
      try {
        const response = await http.get(
          `sip/provisioningwa/api/v2/tenant/extension?tenant_id=${store.getters.currentAccount.id}&extension_id=${id}`
        )
        if (response.data.success) {
          return {
            success: true,
            data: response.data.data
          }
        } else {
          commit('setError', response.data.error.message)
          return {
            success: false,
            errors: response.data.error.errors
          }
        }
      } catch (error) {
        if (error.response) {
          commit('setError', error.response.data.error.message)
          return {
            success: false,
            errors: {}
          }
        } else {
          commit('setError', error.message)
          return {
            success: false,
            errors: {}
          }
        }
      }
    },
    async updateExtension({ commit }, payload) {
      commit('setError', null)
      try {
        const response = await http.put(
          `sip/provisioningwa/api/v2/tenant/extension/${payload.id}`,
          {
            tenant_id: store.getters.currentAccount.id,
            ...payload
          }
        )
        if (response.data.success) {
          return {
            success: true,
            data: { ...response.data.data }
          }
        } else {
          commit('setError', response.data.error.message)
        }
      } catch (error) {
        if (error.response) {
          commit('setError', error.response.data.error.message)
          return {
            success: false,
            errors: { ...error.response.data.error.errors }
          }
        } else {
          commit('setError', error.message)
          return {
            success: false,
            errors: {}
          }
        }
      }
    },
    async resetExtensionPassword({ commit }, extension_id) {
      commit('setError', null)
      try {
        const response = await http.post(
          `sip/provisioningwa/api/v2/tenant/extension/reset `,
          {
            tenant_id: store.getters.currentAccount.id,
            extension_id
          }
        )
        if (response.data.success) {
          return {
            success: true,
            data: { ...response.data.data }
          }
        } else {
          commit('setError', response.data.error.message)
        }
      } catch (error) {
        if (error.response) {
          commit('setError', error.response.data.error.message)
          return {
            success: false,
            errors: { ...error.response.data.error.errors }
          }
        } else {
          commit('setError', error.message)
          return {
            success: false,
            errors: {}
          }
        }
      }
    },
    async fetchDetailRowDataDay({ commit }, id) {
      commit('setError', null)
      try {
        const response = await http.get(
          `sip/provisioningwa/api/v2/tenant/extension/online/data/today?tenant_id=${store.getters.currentAccount.id}&extension_id=${id}`
        )

        if (response.data.success) {
          commit('addDetailRowDataDay', {
            id: id,
            data: response.data.data
          })
          return true
        } else {
          commit('setError', response.data.error.message)
          commit('setReloadTabledata', true)
          return false
        }
      } catch (error) {
        if (error.response) {
          commit('setError', error.response.data.error.message)
          commit('setReloadTabledata', true)
          return false
        } else {
          commit('setError', error.message)
          commit('setReloadTabledata', true)
          return false
        }
      }
    },
    async fetchDetailRowDataMonth({ commit }, id) {
      commit('setError', null)
      try {
        const response = await http.get(
          `sip/provisioningwa/api/v2/tenant/extension/online/data/month?tenant_id=${store.getters.currentAccount.id}&extension_id=${id}`
        )

        if (response.data.success) {
          commit('addDetailRowDataMonth', {
            id: id,
            data: response.data.data
          })
          return true
        } else {
          commit('setError', response.data.error.message)
          commit('setReloadTabledata', true)
          return false
        }
      } catch (error) {
        if (error.response) {
          commit('setError', error.response.data.error.message)
          commit('setReloadTabledata', true)
          return false
        } else {
          commit('setError', error.message)
          commit('setReloadTabledata', true)
          return false
        }
      }
    },
    async fetchDetailRowStatus({ commit }, id) {
      commit('setError', null)
      try {
        const response = await http.get(
          `sip/provisioningwa/api/v2/tenant/extension/online/active?tenant_id=${store.getters.currentAccount.id}&extension_id=${id}`
        )
        if (response.data.success) {
          commit('addDetailRowStatus', {
            id: id,
            data: response.data.data
          })
          return true
        } else {
          commit('setError', response.data.error.message)
          commit('setReloadTabledata', true)
          return false
        }
      } catch (error) {
        if (error.response) {
          commit('setError', error.response.data.error.message)
          commit('setReloadTabledata', true)
          return false
        } else {
          commit('setError', error.message)
          commit('setReloadTabledata', true)
          return false
        }
      }
    },
    async sendCredentialsEmail({ commit }, payload) {
      commit('setError', null)
      try {
        const response = await http.post(
          'sip/provisioningwa/api/v2/tenant/extension/send/mail',
          {
            tenant_id: store.getters.currentAccount.id,
            ...payload
          }
        )
        if (response.data.success) {
          return {
            success: true,
            data: { ...response.data.data }
          }
        } else {
          commit('setError', response.data.error.message)
        }
      } catch (error) {
        if (error.response) {
          commit('setError', error.response.data.error.message)
          return {
            success: false,
            errors: { ...error.response.data.error.errors }
          }
        } else {
          commit('setError', error.message)
          return {
            success: false,
            errors: {}
          }
        }
      }
    },
    async toggleExtensionStatus({ commit }, extension_id) {
      commit('setError', null)
      try {
        const response = await http.post(
          'sip/provisioningwa/api/v2/tenant/extension/status',
          {
            tenant_id: store.getters.currentAccount.id,
            extension_id
          }
        )
        if (response.data.success) {
          return {
            success: true,
            data: { ...response.data.data }
          }
        } else {
          commit('setError', response.data.error.message)
        }
      } catch (error) {
        if (error.response) {
          commit('setError', error.response.data.error.message)
          return {
            success: false,
            errors: {}
          }
        } else {
          commit('setError', error.message)
          return {
            success: false,
            errors: {}
          }
        }
      }
    },
    async fetchAllExtensions({ commit }) {
      commit('setError', null)
      try {
        const response = await http.get(
          `sip/provisioningwa/api/v2/tenant/extension/list?tenant_id=${store.getters.currentAccount.id}`
        )
        if (response.data.success) {
          commit('addAllExtensions', response.data.data)
          return true
        } else {
          commit('setError', response.data.error.message)
          return false
        }
      } catch (error) {
        if (error.response) {
          commit('setError', error.response.data.error.message)
          return false
        } else {
          commit('setError', error.message)
          return false
        }
      }
    },
    async checkExtensionAvailability({ commit }, id) {
      commit('setError', null)
      try {
        const response = await http.get(
          `sip/provisioningwa/api/v2/tenant/extension/deleted/checker?tenant_id=${store.getters.currentAccount.id}&extension_id=${id}`
        )
        if (response.data.success) {
          return {
            success: true,
            data: response.data.data
          }
        } else {
          commit('setError', response.data.error.message)
          return {
            success: false,
            errors: response.data.error.errors
          }
        }
      } catch (error) {
        if (error.response) {
          commit('setError', error.response.data.error.message)
          return {
            success: false,
            errors: {}
          }
        } else {
          commit('setError', error.message)
          return {
            success: false,
            errors: {}
          }
        }
      }
    },
    async fetchPBXUrl({ commit }) {
      commit('setError', null)
      try {
        const response = await http.get(
          `sip/provisioningwa/api/v1/information/pbx-url?tenant_id=${store.getters.currentAccount.id}`
        )
        if (response.data.success) {
          commit('setPbxUrl', response.data.data.url)
          return {
            success: true,
            data: { ...response.data.data }
          }
        } else {
          commit('setError', response.data.error.message)
        }
      } catch (error) {
        if (error.response) {
          commit('setError', error.response.data.error.message)
          return {
            success: false,
            errors: { ...error.response.data.error.errors }
          }
        } else {
          commit('setError', error.message)
          return {
            success: false,
            errors: {}
          }
        }
      }
    }
  }
}
